import shave from 'shave';

export default class cardPartner {

    static get selector() {
      return '.cardPartner';
    }
    
    constructor(el) {
        this.el = el;
        this.link = el.querySelector('.cardPartner__link');
        this.isOpen = false;
        this.body = document.querySelector("body");
        this.bottomWrapper = el.querySelector('.cardPartner__bottomWrapper');
        this.bottom = el.querySelector('.cardPartner__bottom');
        this.linkLabel = el.querySelector('.cardPartner__linkLabel');
        this.closedLabel = this.linkLabel.textContent;
        this.openedLabel = this.linkLabel.dataset.openlabel;
        this.content = el.querySelector('.cardPartner__content');
        this.text = el.querySelector('.cardPartner__shortDescription');
        if(this.text){
          let height = this.content.getBoundingClientRect().bottom - this.text.getBoundingClientRect().top;
          shave(this.text, height ,{ character: "..." });
        }
        
        this.setEvents();
    }

    toggle() {
        if(this.isOpen) this.close();
        else this.open();
    }
    
    open() {
        document.addEventListener('click',  this.e_clickDocument.bind(this));

        if(this.isOpen) return;
        this.el.classList.add('cardPartner--open');
        this.el.classList.add('cardPartner--top');
        var domRect = this.bottom.getBoundingClientRect();

        this.bottomWrapper.style.maxHeight = domRect.height + 'px';
        this.linkLabel.innerHTML = this.openedLabel; 
        this.body.classList.add('layerBlue');

        this.isOpen = true;
    }
    
    close() {
        if(!this.isOpen) return;
        this.el.classList.remove('cardPartner--open');
        this.bottomWrapper.style.maxHeight = '';
        this.linkLabel.innerHTML = this.closedLabel; 

        setTimeout(() => {
            this.el.classList.remove('cardPartner--top');
        }, 200)

        this.body.classList.remove('layerBlue');
        this.isOpen = false;
    }

    

    setEvents() {
        this.link.addEventListener('click', this.e_click.bind(this));

    }

    e_click(e) {
        e.preventDefault();
        this.toggle();
    }

    e_clickDocument(event) {
        var isClickInside = this.el.contains(event.target);
        if (!isClickInside) {
           this.close()
        }
    }
   
}
